import Session from 'shared_modules/Session';
import Fingerprint2 from 'fingerprintjs2';
import get from 'lodash/get';
import find from 'lodash/find';
import includes from 'lodash/includes';
import each from 'lodash/each';

const EVENT_PREFIX = 'WebPOS - ';

export default class Analytics {
  /**
   * Used to initialize the Analytics module.
   */
  static init() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'done' does not exist on type 'Promise<an... Remove this comment to see the full error message
    Session.init().done(() => {
      // register data that will go into every request
      // @ts-expect-error ts-migrate(2351) FIXME: This expression is not constructable.
      new Fingerprint2().get((result: TSFixMe) => {
        try {
          // Only register this once; if it's already defined this becomes a noop.
          // If the cookies are cleaned then this will be regenerated.
          window.mixpanel.register_once({
            webPOSStationUUID: result,
          });

          // This data will be re-registered whenever the init is method is called.
          // This should contain any data that we want to send with every request
          // that can change.
          window.mixpanel.register({
            retailID: Session.accountID(),
            systemUserID: Session.userID(),
            isStencil: !!window.StencilWebAPI.isStencil(),
          });

          // Set the Mixpanel profile ID
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          window.mixpanel.identify(Session.accountID());

          // Set retailID property on the profile
          window.mixpanel.people.set({ retailId: Session.accountID() });

          // Fire on-login / on-page-reload events
          Analytics.submitOnLoginEvents();
        } catch (e) {
          // Mixpanel error goes to void, operation is pursued
        }
      });
    });
  }

  /**
   * Submits any events that need to be fired on user login
   */
  static submitOnLoginEvents() {
    Analytics.submitLastSeenEvent();
  }

  /**
   * Fires the event that tells us when users of a given Employee Role was
   * last active
   */
  static submitLastSeenEvent() {
    window.lsCloud
      .getJSONFromAPI(
        `/API/Account/${Session.accountID()}/Employee/${Session.employeeID()}?load_relations=["EmployeeRole"]`
      )
      .done(data => {
        if (get(data, 'Employee.EmployeeRole.system') !== 'true') {
          return;
        }

        // new Date() defaults to the user's current timezone, but
        // we want it in PST (because the rest of our Mixpanel timestamps
        // are in PST).
        const date = new Date();
        const dateInGMT = new Date(date.valueOf() + date.getTimezoneOffset() * 60000);
        // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
        const dateInPST = new Date(dateInGMT - 7 * 60 * 60 * 1000);

        try {
          switch (data.Employee.EmployeeRole.name) {
            case 'Admin':
              window.mixpanel.people.set({
                adminLastSeenDatePST: dateInPST,
              });
              break;

            case 'Associate':
              window.mixpanel.people.set({
                associateLastSeenDatePST: dateInPST,
              });
              break;

            case 'Manager':
              window.mixpanel.people.set({
                managerLastSeenDatePST: dateInPST,
              });
              break;

            case 'Owner':
              window.mixpanel.people.set({
                ownerLastSeenDatePST: dateInPST,
              });
              break;

            default:
              break;
          }
        } catch (e) {
          // Mixpanel error goes to void, operation is pursued
        }
      });
  }

  /**
   * Fires the event that gives us the list of a user's configured gateways
   */
  static submitGatewaysEvent() {
    $.when(
      window.lsCloud.getJSONFromAPI(`/API/Account/${Session.accountID()}/Shop`),
      window.lsCloud.getJSONFromAPI(`/API/Account/${Session.accountID()}/GatewayConfig`)
    ).done((shopData, gatewayConfigData) => {
      const gatewayIDs: TSFixMe = [];

      if (
        typeof gatewayConfigData.GatewayConfig !== 'undefined' &&
        typeof shopData.Shop !== 'undefined'
      ) {
        let gatewayConfigs = gatewayConfigData.GatewayConfig;
        if (!Array.isArray(gatewayConfigs)) {
          gatewayConfigs = [gatewayConfigs];
        }

        let shops = shopData.Shop;
        if (!Array.isArray(shops)) {
          shops = [shops];
        }

        const shopsWithGateways = shops.filter(
          (shop: TSFixMe) => shop.gatewayConfigID && shop.gatewayConfigID.length > 0
        );

        each(shopsWithGateways, shopWithGateway => {
          const matchingGateway = find(
            gatewayConfigs,
            gatewayConfig => gatewayConfig.gatewayConfigID === shopWithGateway.gatewayConfigID
          );
          if (matchingGateway && !includes(gatewayIDs, matchingGateway.gatewayID)) {
            gatewayIDs.push(matchingGateway.gatewayID);
          }
        });
      }

      try {
        window.mixpanel.people.set({
          activePaymentProcessors: gatewayIDs,
        });
      } catch (e) {
        // Mixpanel error goes to void, operation is pursued
      }
    });
  }

  /**
   * Submits an analytics event.  The event will be prefixed with 'WebPOS - '.
   *
   * @param {string} event       A string used to identify the type of event
   * @param {object} data        An optional object hash containing data to transmit with the event
   * @param {string} eventPrefix Override the default event prefix
   */
  static track(event: TSFixMe, data = {}, eventPrefix = EVENT_PREFIX) {
    try {
      window.mixpanel.track(`${eventPrefix}${event}`, data);
    } catch (e) {
      // Mixpanel error goes to void, operation is pursued
    }
  }
}

// Make the class available to non-ES6 legacy code.  This is a workaround
// until we lose all ES5 support (whenever that is).
window.Analytics = Analytics;
